import { Partner } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

class PartnersService {
    public static readonly getAvailablePartners = async (): Promise<Partner[]> => api.partnerController.getPartners();
}

export { PartnersService };
